import { Tag, Input, Space, Table, TableProps, Divider } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from 'react';
import { MinusCircleOutlined, PlusCircleOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, message, Upload } from 'antd';
import { CustomAxios } from "../../services/api";
import MessageListPopUp from "./message.list.modal";
import { ClubInfosType } from "./common.type";

    interface ChattingPopUpProps {
        agentSeq?: any;
        clubSeq?: any;
    }
    const ChattingPopUp: React.FC<ChattingPopUpProps> = ({  agentSeq ,clubSeq}) => {       
    const [inputValue, setInputValue] = useState(""); // Input 값 상태 추가
    const [checkedTags, setCheckedTags] = useState<{ [key: string]: boolean }>({}); // 체크된 태그 상태 추가

    const timestamp = Date.now();
    const [refresh, setRefresh] = useState(timestamp);
    const handleCheckboxChange = (tag: string, checked: boolean) => {
        setCheckedTags({ ...checkedTags, [tag]: checked }); // 체크된 태그 상태 업데이트
    };

    // 클럽정보가져오기 
    useEffect(() => {        
        requestGetClubInfos();
      }, []);
    // 태그처리 
    const [tagAry, setTagAry] = useState<string[]>([]);             // 서버에서 가져온것 
    const [tagFalseAry, setTagFalseAry] = useState<string[]>([]);             // 서버에서 가져온것   
    
   
    useEffect(() => {
        const newCheckedTags: { [key: string]: boolean } = {};
        tagAry.forEach(tag => {
            newCheckedTags[tag] = true;
        });
        tagFalseAry.forEach(tag => {
            newCheckedTags[tag] = false;
        });
        setCheckedTags(newCheckedTags);
    }, [tagAry, tagFalseAry]);

    const requestGetClubInfos = () => {         
        setCheckedTags({});
        setTagAry([]);
        setTagFalseAry([]);        
        CustomAxios.getClubInfos(
             Number(agentSeq),
             Number(clubSeq)
        ).then(
        (response) => {
            const clubInfos: ClubInfosType = response.data;        
            console.log("clubInfos.memoSetting ",clubInfos.memoSettingTrueList);  
            setTagAry(clubInfos.memoSettingTrueList);  
            setTagFalseAry(clubInfos.memoSettingFalseList); 
        },
        (error) => {
        }
        );
    };
    
    const requestSubmit = () => {  
       
        console.log(" checkedTags:>>> ", checkedTags);   
        const combinedTags = [...tagAry, ...tagFalseAry];
        if (inputValue.trim() !== "") {
            // 중복 검사
            if (!combinedTags.includes(inputValue)) {
                // 중복되지 않으면 추가
                combinedTags.push(inputValue);
            } else {
                // 중복되는 경우 예외 처리
                console.error("중복된 값입니다.");
            }
        }
        const memoSettingData = {
            agentSeq: Number(agentSeq),
            clubSeq: Number(clubSeq),
            memoSetting: JSON.stringify({
                "회원태그": combinedTags.map(tag => ({ [tag]: tag === inputValue ? true : checkedTags[tag] ?? false }))
            })
        };       
        console.log(" memoSettingData:", memoSettingData);
        CustomAxios.patchMemoSetting(memoSettingData)
        .then((response) => {
          console.log("postStudyCreateFile", response);         
          requestGetClubInfos(); 
        })
        .catch((err) => {
          console.log("postStudyCreateFile error", err);
        });
    }; 

    // 변경 클릭시 
    const requestUpdate = (deleteValue : string) => {             
        console.log(" deleteValue:>>> ", deleteValue);   
        console.log(" checkedTags:>>> ", checkedTags);    
        const combinedTags = [...tagAry, ...tagFalseAry];   
        
        if (deleteValue.trim() !== "") {
            // 중복 검사
            if (!combinedTags.includes(deleteValue)) {
            } else {
                // 중복되는 경우 제거
            combinedTags.splice(combinedTags.indexOf(deleteValue), 1);
            console.error("중복된 값입니다. 제거되었습니다.");
            }
        }

        const memoSettingData = {
            agentSeq: Number(agentSeq),
            clubSeq: Number(clubSeq),
            memoSetting: JSON.stringify({
                "회원태그": combinedTags.map(tag => ({ [tag]: tag === inputValue ? true : checkedTags[tag] ?? false }))
            }),
            deleteMemo: deleteValue
        };       
        console.log(" memoSettingData:", memoSettingData);
        CustomAxios.patchMemoSetting(memoSettingData)
        .then((response:any) => {
          console.log("postStudyCreateFile", response);  
          requestGetClubInfos(); 
        })
        .catch((err:any) => {
          console.log("postStudyCreateFile error", err);
        });
    }; 

    
    const handleDeleteChange = (tag: string) => {
        console.log("handleDeleteChange tag", tag);       
        requestUpdate(tag);
    };

    return (
        <div style={{ height: '500px', overflowY: 'auto' }}>  
        <Divider orientation="left" plain orientationMargin="0">사용함</Divider>
         {tagAry.map((tag, index) => (
                    <div>
                    <input 
                    key={`tag_${index}`} 
                    type="checkbox" 
                    id={`tag_${index}`} 
                    name={`tag_${index}`} 
                    value={tag} 
                    checked={checkedTags[tag] || false} // 체크된 태그인지 확인하여 checked 속성 설정
                    onChange={(e) => handleCheckboxChange(tag, e.target.checked)} // 체크 상태 변경 핸들러
                    />
                    <label htmlFor={`tag_${index}`}>{tag}</label>
                    <Button icon={<MinusCircleOutlined />}  onClick={(e) => handleDeleteChange(tag)} style={{marginLeft:20}}>삭제</Button>
                    </div>
                 ))}
        <Divider orientation="left" plain orientationMargin="0">사용안함</Divider>
            {tagFalseAry.map((tag, index) => (
                        <div>
                        <input 
                        key={`tag_${index}`} 
                        type="checkbox" 
                        id={`tag_${index}`} 
                        name={`tag_${index}`} 
                        value={tag} 
                        checked={checkedTags[tag] || false} // 체크된 태그인지 확인하여 checked 속성 설정
                        onChange={(e) => handleCheckboxChange(tag, e.target.checked)} // 체크 상태 변경 핸들러
                        />
                        <label htmlFor={`tag_${index}`}>{tag}</label>
                        <Button icon={<MinusCircleOutlined />}  onClick={(e) => handleDeleteChange(tag)} style={{marginLeft:20}}>삭제</Button>
                        </div>
            ))}
                
         <Divider orientation="left" plain orientationMargin="0">상태변경</Divider>
         <Button icon={<PlusCircleOutlined />}  onClick={(e) => requestUpdate('')}>변경</Button>


         <Divider orientation="left" plain orientationMargin="0">태그추가</Divider>

         <Input style={{ width: '300px', marginRight:10}}
          value={inputValue} // Input 값 설정
          onChange={(e) => setInputValue(e.target.value)} // Input 값 변경 핸들러
         />
         <Button icon={<PlusCircleOutlined />}  onClick={requestSubmit}>추가</Button>
        </div>        
    );
}
export default ChattingPopUp;



